const ReportRoutes = {
    path: '/reprot',
    component: () => import('@/views/Layout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'report-employee-profile',
            path: '/report/employee-profile',
            meta: {
                permissions: 'hrreport:list'
            },
            component: () => import('@/views/report/employee-profile/SearchEmployee.vue')
        }
    ]
};

export default ReportRoutes;
